import { render, staticRenderFns } from "./ExtractMoney.vue?vue&type=template&id=0da4457e&scoped=true"
import script from "./ExtractMoney.vue?vue&type=script&lang=js"
export * from "./ExtractMoney.vue?vue&type=script&lang=js"
import style0 from "./ExtractMoney.vue?vue&type=style&index=0&id=0da4457e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da4457e",
  null
  
)

export default component.exports